import React from "react";
import "react-toastify/dist/ReactToastify.css";

const Information = props => {
  return (
    <div>
      <button onClick={props.notify}>Notify !</button>
    </div>
  );
};

export default Information;
